export default __webpack_public_path__ + "static/media/PPI-steps-001.3e99b081.jpg";